import { render } from "./svg-game.vue?vue&type=template&id=2bfded18"
import script from "./svg-game.vue?vue&type=script&lang=ts"
export * from "./svg-game.vue?vue&type=script&lang=ts"
script.render = render

export default script